import React from "react";
import { Button } from "@src/components";
import { INVALID_VALUE } from "@src/constants/InvalidValue";
import { LectureClassDto, LectureListDto, WEEK_DAY_KOR } from "./service/types";

const cellStyle: React.CSSProperties = {
    width: "100%",
    minWidth: "80px",
    textAlign: "center",
};

const renderSchedule = (lectureClass: LectureClassDto) => {
    return lectureClass.schedules
        .map(
            (schedule) =>
                `${WEEK_DAY_KOR[schedule.weekDay] ?? schedule.weekDay} ${schedule.startTime?.slice(0, 5)}~${schedule.endTime?.slice(0, 5)}`,
        )
        .join(", ");
};

export const getColumns = (navigate: any) => [
    {
        Header: "번호",
        accessor: "no",
        Cell: ({ cell: { value } }: any) => (
            <div style={{ ...cellStyle, minWidth: "50px" }}>
                {value ?? INVALID_VALUE}
            </div>
        ),
    },
    {
        Header: "강의 제목",
        accessor: "title",
        Cell: ({ cell: { value } }: any) => (
            <div style={{ ...cellStyle, minWidth: "160px" }}>
                {value ? value : INVALID_VALUE}
            </div>
        ),
    },
    {
        Header: "요약 소개",
        accessor: "contents",
        Cell: ({ cell: { value } }: any) => (
            <div
                style={{
                    ...cellStyle,
                    minWidth: "200px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
            >
                {value ? value : INVALID_VALUE}
            </div>
        ),
    },
    {
        Header: "클래스",
        accessor: "classes",
        Cell: ({ cell: { value } }: any) => {
            const classes: LectureClassDto[] = value ?? [];
            if (classes.length === 0) {
                return <div style={cellStyle}>{INVALID_VALUE}</div>;
            }
            return (
                <div
                    style={{
                        ...cellStyle,
                        minWidth: "240px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "4px",
                    }}
                >
                    {classes.map((lectureClass) => (
                        <span key={lectureClass.no}>
                            {lectureClass.title}
                            {lectureClass.schedules?.length > 0 &&
                                ` (${renderSchedule(lectureClass)})`}
                        </span>
                    ))}
                </div>
            );
        },
    },
    {
        Header: "정렬",
        accessor: "order",
        Cell: ({ cell: { value } }: any) => (
            <div style={{ ...cellStyle, minWidth: "50px" }}>
                {value ?? INVALID_VALUE}
            </div>
        ),
    },
    {
        Header: "등록일",
        accessor: "createdAt",
        Cell: ({ cell: { value } }: any) => (
            <div style={{ ...cellStyle, minWidth: "100px" }}>
                {value ? value : INVALID_VALUE}
            </div>
        ),
    },
    {
        Header: "관리",
        accessor: "viewMore",
        Cell: ({ row }: any) => {
            const lecture: LectureListDto = row?.original;
            return (
                <div
                    style={{
                        ...cellStyle,
                        minWidth: "180px",
                        display: "flex",
                        gap: "6px",
                        justifyContent: "center",
                    }}
                >
                    <Button
                        color="purple"
                        size="small"
                        label="신청자 조회"
                        handleClick={() => {
                            navigate(`/offline/apply/${lecture.no}`, {
                                state: lecture,
                            });
                        }}
                    />
                    <Button
                        color="gd"
                        size="small"
                        label="수정"
                        handleClick={() => {
                            navigate(`/offline/edit/${lecture.no}`, {
                                state: lecture,
                            });
                        }}
                    />
                </div>
            );
        },
    },
];
